import { Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TOnlineRiskManagementDataTableData = {
  primaryKey: string | number,
  transactionCode: string  | number,
  minTran: string,
  maxTran: string,
  limitAmount: string,
  limitNumber: string,
  curAuthAmount: string,
  curAuthNbr: string,
  curUsageAmount: string,
  curUsageNbr: string,
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TOnlineRiskManagementDataTableData>();

export function getOnlineRiskManagementDataTableColumns({ isLoading }: Props) {
  return [
    columnHelper.accessor('transactionCode', {
      id: 'transactionCode',
      header: 'Transaction Code',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('minTran', {
      id: 'minTran',
      header: 'Tran. Min',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('maxTran', {
      id: 'maxTran',
      header: 'Tran. Max',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('limitAmount', {
      id: 'limitAmount',
      header: 'Amount Limit',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('limitNumber', {
      id: 'limitNumber',
      header: 'Number Limit',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('curAuthAmount', {
      id: 'curAuthAmount',
      header: 'Cur. Auth. Amount',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('curAuthNbr', {
      id: 'curAuthNbr',
      header: 'Cur. Auth. Nbr',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('curUsageAmount', {
      id: 'curUsageAmount',
      header: 'Cur. Usag. Amount',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('curUsageNbr', {
      id: 'curUsageNbr',
      header: 'Cur. Usag. Nbr',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),


  ];
}
